import React from 'react';
import ReactDOM from 'react-dom/client';
import Button from './Button';

const myFirstElement =
  (<>
    <h1>Hello React!
      <Button />
    </h1>
    <Button />
    <Button />
  </>
  )

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(myFirstElement);